import {createReduxHistory} from "../../store/reducers";
import {store} from "../../store/configureStore";
const history = createReduxHistory(store);

export default history;
